if (!customElements.get('variant-discount')) {
  class VariantDiscount extends HTMLElement {
    constructor() {
      super();
      this.variantDiscounts = this.querySelectorAll('.js-variant-discount');
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      if (this.variantDiscounts) {
        // Bind to on:variant:change event for this product
        const variantPicker = this.closest('.product').querySelector('variant-picker');
        if (variantPicker) {
          variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
        }

        if (this.dataset.currentVariantId) {
          this.setVisibleVariantDiscount(this.dataset.currentVariantId);
        }
      }
    }

    /**
     * Sets the visible variant variantDiscounts.
     * @param {string} variantId - The variant id
     */
    setVisibleVariantDiscount(variantId) {
      this.variantDiscounts.forEach((variantDiscount) => {
        variantDiscount.hidden = variantDiscount.dataset.variantId.toString() !== variantId.toString();
      });
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.setVisibleVariantDiscount(evt.detail.variant.id);
      }
    }
  }

  customElements.define('variant-discount', VariantDiscount);
}
